import * as React from 'react';
export const wechatSvg = React.forwardRef(function wechatSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.822 10.24a.523.523 0 0 1-.241.054.525.525 0 0 1-.464-.272l-.037-.073-1.465-3.118a.226.226 0 0 1-.018-.11.245.245 0 0 1 .074-.18.256.256 0 0 1 .185-.073c.06.001.118.02.167.054L5.747 7.72c.135.08.288.124.445.127.096 0 .19-.019.278-.054l8.085-3.518C13.089 2.588 10.698 1.5 8.009 1.5 3.58 1.5 0 4.42 0 8.027c0 1.958 1.075 3.735 2.763 4.933a.467.467 0 0 1 .185.58c-.13.49-.352 1.288-.352 1.324a.639.639 0 0 0-.037.199c-.002.068.025.133.074.18s.116.075.185.073a.213.213 0 0 0 .148-.054l1.743-.998a.896.896 0 0 1 .427-.127c.081.003.162.016.24.036.85.243 1.73.365 2.615.364 4.412 0 8.009-2.92 8.009-6.527a5.64 5.64 0 0 0-.908-3.028l-9.215 5.221z',
    }),
  );
});
wechatSvg.defaultProps = {
  height: '16',
  viewBox: '0 0 16 16',
  width: '16',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var wechat = {
  category: 'paymentmethod',
  colorable: true,
  name: 'wechat',
  svg: wechatSvg,
};
